import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { ConstantsService } from '../constants.service';
import { map } from 'rxjs/operators';
@Injectable({
	providedIn: 'root'
})
export class ContingencyPCSService {

	constructor(private readonly http : HttpClient, private readonly constantsService : ConstantsService) { }
	loadDataContingencyPCS(periodId): Observable<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/giContingencyPCS/getPCSData/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(
				catchError(this.handleError));
	}

	updateContingencyPCS(InData) {
		return this.http.put(`${this.constantsService.baseAPIURL}/giContingencyPCS/updatePCSData`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}
	addContingencyPCS(InData) {
		return this.http.post(`${this.constantsService.baseAPIURL}/giContingencyPCS/addPCSData`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	deleteContingencyPCS(InData) {
		return this.http.post(`${this.constantsService.baseAPIURL}/giContingencyPCS/deletePCSData`, InData, { headers: this.constantsService.httpOptions, responseType: 'text' })
			.pipe(
				catchError(this.handleError));
	}

	getContingencyMasterPCS(periodId): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/giContingencyM/getPCSDate/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}

	getContingencyLLT(periodId): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/giContingencyM/getContingency/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise();
	}


	getDomiciles(periodId): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/giContingencyM/getDomicile/${periodId}`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise()

	}


	getPlantsDockDropDown(_periodId): Promise<any> {
		return this.http
			.get(`${this.constantsService.baseAPIURL}/giContingencyPCS/getPCSData/plant`, this.constantsService.httpCustomOptions)
			.pipe(map(res => res))
			.toPromise()

	}

	private handleError(error: HttpErrorResponse): Observable<never> {
		return throwError(() => error.message || 'Server Error');
	}

}